const experience = [
    {
        companyName: 'Ministry of Justice',
        position: 'Data Scientist (Turing Intern)',
        startDate: 'Apr. 2025',
        endDate: 'Oct. 2025',
        url: 'https://www.gov.uk/government/organisations/ministry-of-justice',
        highlights: [
            'Completed a six-month AI and data science internship at the Ministry of Justice, facilitated by the Alan Turing Institute.',
            'Collaborated with a team of data scientists to evaluate the performance of Large Language Models (LLMs) on free-text extraction.',
            'Designed a framework and code library to quantify gender and ethnic bias across multiple NLP tasks. Generated insights which informed team decisions on model architecture, prompting strategies, and guardrails.',
            'Contributed to an open-source Python package for extracting data from free-text using transformer-based models.'
        ]
    },
    {
        companyName: 'King\'s College London',
        position: 'Research Assistant',
        url: 'https://www.kcl.ac.uk/',
        startDate: 'Jan. 2023',
        endDate: 'Sep. 2023',
        highlights: [
            'Led a team of five researchers across UCL and King\'s College on an industry-sponsored project investigating the privacy practices of female health apps.',
            'Conducted privacy audits of 20 popular apps on the Google Play Store and published the findings in a prestigious ACM conference.',
            'Wrote a briefing report for a leading period-tracking app company and consulted on their privacy strategy.'
        ]

    },

    {
        companyName: 'Statkraft',
        position: 'Data Analyst',
        url: 'https://www.statkraft.com/',
        startDate: 'Jul. 2020',
        endDate: 'Sep. 2021',
        highlights: ['Developed an ETL pipeline for scraping, pre-processing, and analysing geo-spatial and free-text datasets.',
            'Built time series and Bayesian models to predict fuel supply and demand in the UK, and investigated the use of Markov Chains to predict global shipping movements.',
            'Developed interactive visualisations and a GUI for data manipulation, supporting traders and analysts with strategic decision-making.'
        ]
    }

]

export default experience;